<template>
	<div :class="classObj" class="app-wrapper">
		<!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
		<!-- <sidebar class="sidebar-container" /> -->
		<div class="app-box">
			<!-- <header class="header-container"> -->
			<router-view name="nav" />
			<!-- </header> -->
			<!-- <div class="search-container sg-center-padding"> -->
			<router-view name="search" />
			<!-- </div> -->
			<!-- <div class="main-container"> -->
			<!-- <div class="fixed-header"></div> -->

			<app-main />

			<!-- <router-view name="icon" />
      <router-view name="single" />
      <router-view name="multi"/> -->
			<!-- <right-panel v-if="showSettings">
        <settings />
      </right-panel> -->
			<!-- </div> -->
			<router-view name="rightPanel" />
			<footer class="footer-container">
				<div class="footer-center-container sg-center-padding">
					<div class="footer-top-wrap">
						<router-view name="footerTop" />
					</div>
					<router-view name="footerCenter" />
				</div>
				<router-view name="footerBottom" />
				<!-- <router-view name="logFooterTop" />
        <router-view name="footerWhiteBottom" /> -->
			</footer>
		</div>
	</div>
</template>

<script>
// import RightPanel from '@/components/RightPanel'
import {AppMain} from "./components"
import ResizeMixin from "./mixin/ResizeHandler"
import {mapState} from "vuex"

export default {
	name: "Layout",
	components: {
		AppMain
	},
	mixins: [ResizeMixin],
	computed: {
		...mapState({
			sidebar: (state) => state.app.sidebar,
			device: (state) => state.app.device,
			showSettings: (state) => state.settings.showSettings,
			needTagsView: (state) => state.settings.tagsView,
			fixedHeader: (state) => state.settings.fixedHeader
		}),
		classObj() {
			return {
				// hideSidebar: !this.sidebar.opened,
				// openSidebar: this.sidebar.opened,
				// withoutAnimation: this.sidebar.withoutAnimation,
				mobile: this.device === "mobile"
			}
		}
	},
	methods: {
		handleClickOutside() {
			this.$store.dispatch("app/closeSideBar", {withoutAnimation: false})
		}
	},
	// beforeRouteEnter(to, from){
	//   console.log(to)
	//   console.log(from)
	//   console.log("+++++++++")

	// }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
	@include clearfix;
	position: absolute;
	// position: relative;
	min-height: 100%;
	min-width: 100%;
	background-color: #f2f4f5;
	display: flex;
	flex-direction: column;
	align-items: center;
	.app-box {
		// margin-left: 14px;
		// margin-right: 110px;
		// margin-right: 50px;
		width: 100%;
		box-sizing: border-box;
	}

	// .header-container {
	// 	//   padding: 0 calc(50% - 600px);
	// 	background: rgba(29, 32, 137, 1);
	// 	width: 100%;
	// }
	.search-container {
		// background-color: #fff;
		// padding: 0 calc(50% - 600px);
		// overflow: hidden;
	}

	.footer-container {
		// background-color: #fff;
		background: rgba(255, 255, 255, 1);
		width: 100%;
		.footer-top-wrap {
			// border-bottom: 2px solid rgba(194, 194, 194, 1);
		}
		.footer-center-container {
			// padding: 0 calc(50% - 600px);
			background: rgba(255, 255, 255, 1);
		}
	}

	&.mobile.openSidebar {
		position: fixed;
		top: 0;
	}
}

.drawer-bg {
	background: #000;
	opacity: 0.3;
	width: 100%;
	top: 0;
	height: 100%;
	position: absolute;
	z-index: 999;
}

.fixed-header {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 9;
	width: 100%;
	// width: calc(100% - #{$sideBarWidth});
	// transition: width 0.28s;
}

.hideSidebar .fixed-header {
	// width: calc(100% - 54px)
}

.mobile .fixed-header {
	width: 100%;
}
</style>
